<template>
    <div class="list-header row">
<!--      TODO проверить использование этого компонента-->
    </div>
</template>

<script>
export default {
    name: 'AccountsHistoryListHeader',
};
</script>

<style scoped lang="scss">
.list-header {
    height: 0;
    padding: 0;

    border-bottom: none;
}
</style>
